import React from 'react';
import { CalendarIcon } from 'lucide-react';
import { upcomingEngagements, pastEngagements, mediaFeatures, images } from '../data/profile';
import { PageHeader } from '../components/PageHeader';
import { PortraitFrame } from '../components/PortraitFrame';
export function Speaking() {
  return <section className="bg-parchment py-16 lg:py-24" data-id="element-246" data-mp="2vazhk7ruxe2v">
      <div className="mx-auto max-w-dossier px-6 lg:px-10" data-id="element-247" data-mp="2vcahtxm3g3p8">
        <PageHeader overline="Speaking & Media" title="On stage and on the record" description="A sustained public voice on AI in the workforce, modern total rewards, mental health at work, and the future of benefits." data-id="element-248" data-mp="3sx6ldfgc72e6" />

        <div className="mt-14 grid gap-10 lg:grid-cols-2 lg:gap-12" data-id="element-249" data-mp="3e0z3ilseid22">
          <PortraitFrame src={images.keynote} alt="Samanntha DuBridge delivering a keynote on modern total rewards at the Silicon Valley Employers Forum" caption="Keynote on Modern Total Rewards — Silicon Valley Employers Forum, 2025." backdropClass="bg-brass" archClass="rounded-t-[6rem]" aspectClass="aspect-[4/3]" data-id="element-250" data-mp="3e0pbksnspvtq" />
          <PortraitFrame src={images.panel} alt="Samanntha DuBridge on a panel at the From Day One conference in Silicon Valley" caption="Panel — From Day One, Silicon Valley: how people leaders lead through AI and rapid change." backdropClass="bg-emerald" archClass="rounded-t-[6rem]" aspectClass="aspect-[4/3]" data-id="element-251" data-mp="2go035aukcsn5" />
        </div>

        <div className="mt-20" data-id="element-252" data-mp="1xs09lvlxth1g">
          <h2 className="font-display text-3xl text-navy" data-id="element-253" data-mp="1j1j9cfl1gx65">Upcoming engagements</h2>
          <ul className="mt-8 grid gap-6 lg:grid-cols-3 lg:gap-8" data-id="element-254" data-mp="1o03z1l2nzygc">
            {upcomingEngagements.map(event => <li key={event.title} className="flex flex-col bg-navy p-8" data-id="element-255" data-mp="19zt86i1cujv6">
                <span className="inline-flex items-center gap-2 font-sans text-xs uppercase tracking-overline text-emerald-200" data-id="element-256" data-mp="1e1wuk1pkb8v8">
                  <CalendarIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-257" data-mp="3gov4n013gz7a" />
                  {event.timing}
                </span>
                <h3 className="mt-5 font-display text-xl leading-snug text-white" data-id="element-258" data-mp="3bwahuiglvmd9">{event.title}</h3>
                <p className="mt-auto pt-6 font-sans text-sm text-navy-200/80" data-id="element-259" data-mp="36zbpo5gi5php">{event.venue}</p>
              </li>)}
          </ul>
        </div>

        <div className="mt-20 grid gap-14 lg:grid-cols-2 lg:gap-16" data-id="element-260" data-mp="3ilaazz1603c">
          <div data-id="element-261" data-mp="3fpd5dv0bffy">
            <h2 className="font-display text-3xl text-navy" data-id="element-262" data-mp="3uomgov81w5in">Past events</h2>
            <ul className="mt-8 space-y-7" data-id="element-263" data-mp="3umjr2cat8eeg">
              {pastEngagements.map(event => <li key={event.title} data-id="element-264" data-mp="3prcsfiwedzwe">
                  <p className="font-sans text-[17px] font-medium leading-snug text-navy" data-id="element-265" data-mp="3lo7uzur6coem">
                    {event.title}
                  </p>
                  <p className="mt-2 font-sans text-sm text-navy-400" data-id="element-266" data-mp="2ebftd1uuhzlg">
                    {event.venue} · {event.timing}
                  </p>
                </li>)}
            </ul>
          </div>

          <div data-id="element-267" data-mp="poe35u9by36z">
            <h2 className="font-display text-3xl text-navy" data-id="element-268" data-mp="ts29yaq50ur6">Interviews, features &amp; podcasts</h2>
            <ul className="mt-8 space-y-7" data-id="element-269" data-mp="yr5bhl6wsiue">
              {mediaFeatures.map(item => <li key={item.title} data-id="element-270" data-mp="13hvit3ywavrq">
                  <p className="font-sans text-[17px] font-medium leading-snug text-navy" data-id="element-271" data-mp="13ix74a4x9ere">
                    {item.title}
                  </p>
                  <p className="mt-2 font-sans text-sm text-navy-400" data-id="element-272" data-mp="18j2uhe45sf3o">
                    {item.venue} · {item.timing}
                  </p>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}